export const jsonSchema = {
  type: 'array',
  items: {
    type: 'object',
    properties: {
      text: {
        type: 'string',
        description: 'テキストの内容'
      },
      count: {
        type: 'number',
        description: '文字数'
      },
      isExpanded: {
        type: 'boolean',
        description: '展開状態'
      }
    },
    required: ['text', 'count', 'isExpanded']
  }
};
